import { Workflow } from '@shared/store/workflow/workflow.store';

import { QuarterCloseChecklistSection } from '../models/quarter-close-checklist.model';

export function sectionCompletedTotals(
  section: QuarterCloseChecklistSection,
  workflowList: Workflow[]
): string {
  if (!workflowList.length) {
    return '0';
  }

  const sectionKey = Object.entries(QuarterCloseChecklistSection).find(([, value]) => {
    return value === section;
  })?.[1];

  const completedWorkflows = workflowList.filter((workflow) => {
    return (
      sectionKey === (workflow.section as keyof typeof QuarterCloseChecklistSection) &&
      workflow.properties.locked
    );
  });

  return `${completedWorkflows.length}`;
}
